import { useState } from 'react';
import { useColorContext } from '../Components/Colorize/ColorContext';
import { getContrastRatio } from '../Components/Colorize/getTextColor';
import { Link } from 'react-router-dom';
import chroma from 'chroma-js';
import '../Styles/savedAndThemes.scss';
import Header from '../Components/ReusableComponents/Header';
import { CloseButton, PopupDefaultSmall } from "../Components/ReusableComponents/PopupDefaultSmall";
import { useAuthModal } from '../Components/Auth/AuthModalManager';
import { usePopupQueue } from '../Components/ReusableComponents/usePopupQueue';
import { useAuth } from '../contexts/AuthContext';
import Loader from '../Components/ReusableComponents/Loader';
import MiniLoader from '../Components/ReusableComponents/MiniLoader';

function Saved() {
  const { savedPalettes, removePalette, isLoggedIn } = useColorContext();
  const { openLogin, openSubscribe } = useAuthModal();
  const { activePopups, addPopup } = usePopupQueue();
  const { subscriptionActive, subscriptionLoading, loading } = useAuth();

  const handleViewPalette = (palette) => {
    if (!palette.palette_data) {
      return;
    }

    // Import your URL encoding function
    const { encodeStateToURL } = require('../Utils/urlStateUtils');

    const paletteData = palette.palette_data;
    const { palettes } = paletteData;

    // Determine which palettes exist
    const showDuo = !!palettes.duo;
    const showTrio = !!palettes.trio;

    // Get the palette data (use mono as fallback if duo/trio don't exist)
    const monoData = palettes.mono || palettes.duo || palettes.trio;
    const duoData = palettes.duo;
    const trioData = palettes.trio;

    // console.log('🟡 SAVED: monoData.tailwindFamily =', monoData?.tailwindFamily); // ADD THIS

    // Build the state object
    const stateForURL = {
      color: monoData?.color || '',
      colorDuo: duoData?.color || '',
      colorTrio: trioData?.color || '',
      showDuo,
      showTrio,
      paletteModifiers: monoData?.paletteModifiers || {
        scale: { hue: 0, lightnessLeft: 0, lightnessRight: 0, saturationLeft: 0, saturationRight: 0 },
        individual: {}
      },
      paletteModifiersDuo: duoData?.paletteModifiers || {
        scale: { hue: 0, lightnessLeft: 0, lightnessRight: 0, saturationLeft: 0, saturationRight: 0 },
        individual: {}
      },
      paletteModifiersTrio: trioData?.paletteModifiers || {
        scale: { hue: 0, lightnessLeft: 0, lightnessRight: 0, saturationLeft: 0, saturationRight: 0 },
        individual: {}
      },
      squareNames: monoData?.squareNames || ["50", "100", "200", "300", "400", "500", "600", "700", "800", "900", "950"],
      // nienke 15 feb
      tailwindFamily: monoData?.tailwindFamily || null,        // ADD THIS
      tailwindFamilyDuo: duoData?.tailwindFamily || null,      // ADD THIS
      tailwindFamilyTrio: trioData?.tailwindFamily || null  
    };

    // console.log('🟡 SAVED: stateForURL.tailwindFamily =', stateForURL.tailwindFamily); // ADD THIS
    // Generate the URL with encoded state
    const urlPath = encodeStateToURL(stateForURL);

    console.log('🟡 SAVED: urlPath', urlPath); // ADD THIS
    const fullURL = `${window.location.origin}${urlPath}`;

    window.open(fullURL, '_blank');
  };


  const [confirmRemovePopup, setConfirmRemovePopup] = useState(false);
  const [paletteToDelete, setPaletteToDelete] = useState(null);
  const [isDeleting, setIsDeleting] = useState(false);

  const openDeleteConfirmation = (palette) => {
    setPaletteToDelete(palette);
    setConfirmRemovePopup(true);
  };

  const handleConfirmDelete = async () => {
    if (paletteToDelete !== null) {
      setIsDeleting(true);
      await removePalette(paletteToDelete.id); // ADD 'await' here
      setIsDeleting(false);
      setPaletteToDelete(null);
    }
    setConfirmRemovePopup(false);
  };

  const handleCancelDelete = () => {
    setPaletteToDelete(null);
    setConfirmRemovePopup(false);
  };


  const copyToClipboard = async (colorCode) => {
    try {

      // Ensure the color code includes the # if it's a hex color
      const formattedColor = colorCode.startsWith('#') ? colorCode : `#${colorCode}`;

      await navigator.clipboard.writeText(formattedColor);
      addPopup(
        <span className="copied">
          Copied "{formattedColor}"
        </span>,
        4000,
        'copy'
      );

    } catch (err) {
      console.error('Failed to copy color to clipboard:', err);
      // Fallback for older browsers - define formattedColor here too
      const formattedColor = colorCode.startsWith('#') ? colorCode : `#${colorCode}`;
      const textArea = document.createElement('textarea');
      textArea.value = formattedColor;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
    }
  };

  const handleUpgradeClick = () => {
    openSubscribe();
  };

  // Determine the view state once all loading is complete
  const getViewState = () => {
    
    
    if (subscriptionLoading || loading) {
      return 'loading';
    }

    if (!isLoggedIn) {
      return 'logged-out';
    }

    if (savedPalettes.length === 0) {
      return 'no-palettes';
    }

    if (!subscriptionActive) {
      return 'needs-subscription';
    }

    return 'show-palettes';
  };

  const viewState = getViewState();

  return (
    <div className="saved">

      {confirmRemovePopup && (
        <PopupDefaultSmall onClose={handleCancelDelete}>
          <CloseButton onClose={handleCancelDelete} />
          <div className="popup-content">
            <p>Are you sure you want to delete this color palette?</p>
            <div className="btns-container">
              <button className="cancel-btn qua-btn btn-fixedW" onClick={handleCancelDelete}>
                <span>Cancel</span>
              </button>
              <button className="confirm-delete-btn err-btn btn-fixedW" onClick={handleConfirmDelete}>
                  <span>{isDeleting ? <MiniLoader /> : 'Delete'} </span>
              </button>
            </div>
          </div>
        </PopupDefaultSmall>
      )}

      

      {/* new */}
      {viewState === 'loading' && (
        <Loader/>
      )}

      {viewState === 'logged-out' && (
        <Header
          titleHighlighted="All your saved palettes"
          titleNeutral="together in one place"
          text="Log in to access your saved palettes and start building your collection."
        >
          <button onClick={openLogin} className="saved-action-btn pri-btn">
            <span>Log in/Sign up</span>
          </button>
        </Header>
      )}

      {viewState === 'no-palettes' && (
        <Header
          titleHighlighted="All your saved palettes"
          titleNeutral="together in one place"
          text="You don't have any saved palettes yet."
        >
          <Link to="/generator" className="saved-action-btn pri-btn">
            <span>Create a scale or palette</span>
          </Link>
        </Header>
      )}

      {viewState === 'needs-subscription' && (
        <Header
          titleHighlighted="Unlock premium features"
          titleNeutral="and take your palettes further"
          text="Subscribe to access your saved colors and unlock premium features."
        >
          <button onClick={handleUpgradeClick} className="saved-action-btn pri-btn">
            <span>Subscribe</span>
          </button>
        </Header>
      )}

      {viewState === 'show-palettes' && (
        <>
          <Header
            titleHighlighted="All your saved palettes"
            titleNeutral="together in one place"
            text="Click 'View' below to view and/or customize your palette."
          />

          <div className="scales--container">
            {savedPalettes.map((savedItem, index) => (

              <div className="scales--card" key={savedItem.id}>

                <div className="scales--header">
                  <div className="scales--actions">
                    <button
                      className="action delete-btn svg---text"
                      onClick={() => openDeleteConfirmation(savedItem)}
                      title="Delete Scale"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="22" height="22" viewBox="0 0 24 24" fill="none">
                        <path d="M14.7404 9L14.3942 18M9.60577 18L9.25962 9M19.2276 5.79057C19.5696 5.84221 19.9104 5.89747 20.25 5.95629M19.2276 5.79057L18.1598 19.6726C18.0696 20.8448 17.0921 21.75 15.9164 21.75H8.08357C6.90786 21.75 5.93037 20.8448 5.8402 19.6726L4.77235 5.79057M19.2276 5.79057C18.0812 5.61744 16.9215 5.48485 15.75 5.39432M3.75 5.95629C4.08957 5.89747 4.43037 5.84221 4.77235 5.79057M4.77235 5.79057C5.91878 5.61744 7.07849 5.48485 8.25 5.39432M15.75 5.39432V4.47819C15.75 3.29882 14.8393 2.31423 13.6606 2.27652C13.1092 2.25889 12.5556 2.25 12 2.25C11.4444 2.25 10.8908 2.25889 10.3394 2.27652C9.16065 2.31423 8.25 3.29882 8.25 4.47819V5.39432M15.75 5.39432C14.5126 5.2987 13.262 5.25 12 5.25C10.738 5.25 9.48744 5.2987 8.25 5.39432" stroke="#211f1c" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span>Delete</span>
                    </button>
                    <button
                      className="action view-btn svg---text"
                      onClick={() => handleViewPalette(savedItem)}
                      title="View Scale"
                    >
                      <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 22 22" fill="none">
                        <path d="M1.8659 11.2955C1.80257 11.1055 1.80251 10.8998 1.86573 10.7098C3.13839 6.88391 6.74737 4.125 11.0007 4.125C15.2521 4.125 18.8597 6.88135 20.1339 10.7045C20.1973 10.8945 20.1973 11.1002 20.1341 11.2902C18.8614 15.1161 15.2525 17.875 10.9991 17.875C6.74774 17.875 3.14014 15.1187 1.8659 11.2955Z" stroke="#211f1c" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                        <path d="M13.75 11C13.75 12.5188 12.5188 13.75 11 13.75C9.48119 13.75 8.24998 12.5188 8.24998 11C8.24998 9.48122 9.48119 8.25 11 8.25C12.5188 8.25 13.75 9.48122 13.75 11Z" stroke="#211f1c" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
                      </svg>
                      <span>View</span>
                    </button>

                  </div>
                </div>

                {/* The rest of the component remains the same */}
                <div className="scales--content">
                  {['mono', 'duo', 'trio']
                    .filter(key => savedItem.palette_data.palettes[key])
                    .map(key => {
                      const paletteData = savedItem.palette_data.palettes[key];
                      return (
                        <div className="scale--content" key={key}>

                          <h4 className="color-name">{paletteData.colorName}</h4>

                          <div className="squares">
                            <div className="squares--container">
                              {paletteData.palette.map((shade, idx) => (
                                <div
                                  key={idx}
                                  className={`square-container ${paletteData.selectedIndex === idx ? 'picked-color' : ''}`}
                                >
                                  <div
                                    className="square"
                                    style={{
                                      backgroundColor: shade,
                                      color: getContrastRatio(shade, '#ffffff') > 2.0
                                        ? '#ffffff' : '#211f1c'
                                    }}
                                    onClick={() => copyToClipboard(shade.startsWith('hsl') ? chroma(shade).hex() : shade)}
                                  >
                                    {paletteData.selectedIndex === idx && (
                                      <svg className="flag-icon" xmlns="http://www.w3.org/2000/svg" width={18} height={18} viewBox="0 0 17 17" fill="none">
                                        <ellipse cx="5.66667" cy="15.2292" rx="5.66667" ry="1.77083" fill="currentColor" />
                                        <path d="M16.2923 1.41667H6.37565V0H4.95898V14.1667H6.37565V8.5H16.2923L14.8757 4.95833L16.2923 1.41667ZM12.0423 4.95833C12.0423 5.7375 11.4048 6.375 10.6257 6.375C9.84648 6.375 9.20898 5.7375 9.20898 4.95833C9.20898 4.17917 9.84648 3.54167 10.6257 3.54167C11.4048 3.54167 12.0423 4.17917 12.0423 4.95833Z" fill="currentColor" />
                                      </svg>
                                    )}
                                    <p className="variable">{paletteData.squareNames[idx]}</p>
                                    <p className="color-code">
                                      {(shade.startsWith('hsl') ? chroma(shade).hex() : shade).replace('#', '')}
                                    </p>
                                  </div>
                                </div>
                              ))}

                            </div>

                          </div>
                        </div>
                      )
                    })}
                </div>

                <div className="scales--footer">
                  <p>
                    Saved on {new Date(savedItem.created_at).toLocaleDateString()}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </>
      )}

    


      {/* NEW SINGLE POPUP */}
      {activePopups.length > 0 && (
        <div className="popup-timed-container centered">
          {activePopups.map((popup) => (
            <div
              key={popup.id}
              className={`popup-timed ${popup.type || 'default'}`}
              style={{ minHeight: 'auto' }} // Reset dimensions
            >
              <div className="popup-timed-content">
                <div className="content">
                  {popup.type === 'error' ? (
                    // Error/warning icon
                    <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M12 9v3.75m-9.303 3.376c-.866 1.5.217 3.374 1.948 3.374h14.71c1.73 0 2.813-1.874 1.948-3.374L13.949 3.378c-.866-1.5-3.032-1.5-3.898 0L2.697 16.126ZM12 15.75h.007v.008H12v-.008Z" />
                    </svg>

                  ) : (
                    // Success/checkmark icon (default)
                    <svg width={24} height={24} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor">
                      <path strokeLinecap="round" strokeLinejoin="round" d="M9 12.75 11.25 15 15 9.75M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
                    </svg>
                  )}
                  {popup.message}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>

  );
}

export default Saved;